module.exports = __webpack_public_path__ + "static/media/modelo-caixa.03dcf066.svg";